import {BOOKSUBMIT , REMOVEFLIGHT} from './actionTypes';

const initialState = {
    ticket: []
}
const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case BOOKSUBMIT:
            return {
                ...state,
                ticket: [
                    ...state.ticket,
                    {
                        id: action.id,
                        from: action.from,
                        to: action.to,
                        date: action.date,
                        guests: action.guests,
                        ticketclass: action.ticketclass,
                    }
                ]          
            };         
        case REMOVEFLIGHT:         
            return {
                ...state,
                ticket: state.ticket.filter(value => value.id !== action.id),
            };
        default:
            return state;
    }
}

export default formReducer;